function flattenFormikError(error) {
    if (typeof error === 'string')
        return error;
    if (error && typeof error === 'object') {
        const nested = Object.values(error).find((value) => typeof value === 'string');
        if (typeof nested === 'string')
            return nested;
    }
    return undefined;
}
function getByPath(source, path) {
    if (!source || typeof source !== 'object')
        return undefined;
    if (!path.includes('.'))
        return source[path];
    return path.split('.').reduce((acc, key) => {
        if (!acc || typeof acc !== 'object')
            return undefined;
        return acc[key];
    }, source);
}
function isTouchedAtPath(touched, path) {
    const value = getByPath(touched, path);
    if (value === true)
        return true;
    if (value && typeof value === 'object') {
        return Object.values(value).some((nested) => nested === true || (nested != null && typeof nested === 'object'));
    }
    return false;
}
export const getErrorMessage = (name, formik) => {
    const error = getByPath(formik.errors, name);
    if (!error)
        return undefined;
    const show = isTouchedAtPath(formik.touched, name) || (formik.submitCount ?? 0) > 0;
    if (!show)
        return undefined;
    return flattenFormikError(error);
};
export function touchAllFields(formik) {
    formik.setTouched(Object.fromEntries(Object.keys(formik.initialValues).map((key) => [key, true])), true);
}
export async function validateAndTouchAll(formik) {
    const errors = await formik.validateForm();
    touchAllFields(formik);
    return Object.keys(errors).length === 0;
}
/** Map API field keys (e.g. `province`) to form field names (e.g. `name`). */
export function mapApiFieldErrorsForForm(fieldErrors, fieldMap, formFields) {
    const mapped = {};
    for (const [serverField, message] of Object.entries(fieldErrors)) {
        const formField = fieldMap[serverField] ?? (formFields.includes(serverField) ? serverField : undefined);
        if (formField && message.trim()) {
            mapped[formField] = message.trim();
        }
    }
    return mapped;
}
/** Apply server `fieldErrors` to Formik so inline validation messages appear after submit. */
export function applyApiFieldErrorsToFormik(fieldErrors, helpers, options) {
    const mapped = mapApiFieldErrorsForForm(fieldErrors, options.fieldMap ?? {}, options.formFields);
    if (Object.keys(mapped).length === 0)
        return false;
    helpers.setErrors(mapped);
    for (const field of Object.keys(mapped)) {
        helpers.setFieldTouched(field, true, false);
    }
    return true;
}
